// pages/Home.js
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import HomeHero from '../components/HomeHero';
import About from '../components/About';
import PathwaysSection from '../components/PathwaysSection';
import FeaturedProjects from '../components/FeaturedProjects';
import Skills from '../components/Skills';
import Contact from '../components/Contact';
import LightFooter from '../components/LightFooter';
import SEO from '../components/SEO';
import { useLoading } from '../context/LoadingContext';
import { useLanguage } from '../context/LanguageContext';

const Home = () => {
    const location = useLocation();
    const { isInitialLoading } = useLoading();
    const { language } = useLanguage();

    // Enhanced scroll to top when navigating to Home page
    useEffect(() => {
        // Only scroll to top if not in initial loading state
        if (!isInitialLoading) {
            // Immediate scroll to top
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'instant'
            });

            // Additional smooth scroll after a brief delay to ensure DOM is ready
            const timer = setTimeout(() => {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            }, 100);

            return () => clearTimeout(timer);
        }
    }, [location.pathname, isInitialLoading]);

    const seoDescriptions = {
        en: "Senior creative technologist: fifteen years in broadcast and virtual production for Italian national television, full-stack developer (React, Three.js, Python), Unreal Authorized Instructor.",
        it: "Senior creative technologist: quindici anni in broadcast e virtual production per la televisione nazionale italiana, sviluppatore full-stack (React, Three.js, Python), Unreal Authorized Instructor."
    };

    const homeSchema = {
        "@context": "https://schema.org",
        "@type": "ProfilePage",
        "mainEntity": {
            "@type": "Person",
            "name": "Paolo Allegretti",
            "jobTitle": "Senior Creative Technologist",
            "description": seoDescriptions[language],
            "url": "https://paoloallegretti.com"
        }
    };

    return (
        <>
            <SEO
                url="/"
                description={seoDescriptions[language]}
                language={language}
                schema={homeSchema}
            />
            <HomeHero />
            <PathwaysSection />
            <FeaturedProjects />
            <div className="about">
                <About />
            </div>
            <Skills />
            <Contact />
            <div className="bg-black px-8 md:px-16 pb-8">
                <LightFooter showFullPortfolioLink={false} />
            </div>
        </>
    );
};

export default Home;